export default __webpack_public_path__ + "1e77c22c949e096cea98591d5bb53608.png";